import { useEffect } from "react";
import { Outlet } from "react-router";
import { useAppDispatch } from "app/hooks";
import { setLastViewedChecklist } from "pages/order/orderSlice";
import LoadingPage from "pages/loading/LoadingPage";
import { useGetChecklistCommentsQuery, useGetChecklistQuery } from "app/api/checklists";
import ChecklistProvider from "context/ChecklistContext";
import useAssertParams from "hooks/useAssertParams";
import ErrorPage from "pages/error/ErrorPage";

export type ChecklistParams = {
  checklistId: string;
};

const ChecklistPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const { checklistId } = useAssertParams<ChecklistParams>("checklistId");
  const { data: checklist, isLoading: isChecklistLoading } = useGetChecklistQuery(checklistId);
  const { data: comments, isLoading: isCommentsLoading } = useGetChecklistCommentsQuery({
    checklistId,
  });

  useEffect(() => {
    if (!checklist) return;
    dispatch(setLastViewedChecklist(checklist.id));
  }, [checklist, dispatch]);

  if (isChecklistLoading || isCommentsLoading) {
    return <LoadingPage />;
  }

  if (!checklistId || !checklist || !comments) return <ErrorPage.NotFound />;

  return (
    <ChecklistProvider checklist={checklist} comments={comments}>
      <Outlet />
    </ChecklistProvider>
  );
};

export default ChecklistPage;
